export const BASE = "/";
export const LOGIN = "/login";
export const REGISTRATION = "/registration";
export const FORGOT = "/forgot";
export const RESET = "/reset";
export const ACTIVATE = "/activate";
export const MENU = "/menu";
export const PRODUCT = "/product";
export const CONTACTS = "/contacts";
export const CART = "/cart";
export const ORDER = "/order";
export const ORDER_FINALIZE = "/order/finalize";
export const OAUTH2_REDIRECT = "/oauth2/redirect";


export const ACCOUNT = "/account";
export const ACCOUNT_USER_INFO = "/account/user/info";
export const ACCOUNT_USER_EDIT = "/account/user/edit";
export const ACCOUNT_USER_ORDERS = "/account/user/orders";
export const ACCOUNT_ADMIN_ADD_ADDRESS = "/account/user/myaddress";

export const ACCOUNT_ADMIN_ADD = "/account/admin/add";
export const ACCOUNT_ADMIN_PERFUMES = "/account/admin/perfumes";
export const ACCOUNT_ADMIN_ORDERS = "/account/admin/orders";
export const ACCOUNT_ADMIN_USERS = "/account/admin/users";
export const ACCOUNT_ADMIN_EDIT = "/account/admin/edit";
export const ACCOUNT_ADMIN_HOME = "/account/admin/manage-home";
export const ACCOUNT_ADMIN_DIST_STOCK = "/account/distributor/stock";
export const ACCOUNT_ADMIN_PINCODES = "/account/admin/pincodes";
export const ACCOUNT_ADMIN_ADD_DIST = "/account/admin/add-dist";
export const ACCOUNT_ADMIN_ADD_ME = "/account/admin/add-me";
export const ACCOUNT_ADMIN_ADD_EMP = "/account/admin/add-emp";
export const ACCOUNT_ADMIN_DIST_ORDERS = "/account/distributor/orders";
export const ACCOUNT_ORDER_INVOICE = "/account/user/orders/:id/invoice";



